/* Presentation state only. Inventory and subscriptions remain with Shopify/Klaviyo. */
(function(root){
 function state(mode,variant,formId){
  const presale=mode==='presale';
  const useForm=presale&&Boolean(formId);
  return {presale,showPurchase:!presale&&Boolean(variant?.available),showNotify:Boolean(variant)&&(useForm||!variant.available),useForm};
 }
 const api={state};
 if(typeof module==='object'&&module.exports)module.exports=api;
 else root.ParkPDPInventory=api;
})(typeof window==='undefined'?globalThis:window);
